import { Link } from "react-router-dom";
import PageHero from "@/components/site/PageHero";
import Reveal from "@/components/site/Reveal";
import { EXHIBITION_IMAGES } from "@/data/content";
import { useT, useRoute } from "@/i18n";

export default function OurServices() {
  const t = useT();
  const route = useRoute();
  return (
    <div data-testid="services-page" className="bg-white">
      <PageHero
        eyebrow={t.pages.services.eyebrow}
        title={t.pages.services.title}
        subtitle={t.pages.services.subtitle}
        image={EXHIBITION_IMAGES[3]}
      />

      <section className="py-24 md:py-32">
        <div className="max-w-[1400px] mx-auto px-6 md:px-10 lg:px-14">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-10 lg:gap-16 mb-16">
            <Reveal className="lg:col-span-1">
              <p className="eyebrow">{t.pages.services.eyebrow}</p>
              <h2 className="heading-display mt-4 text-4xl sm:text-5xl lg:text-6xl uppercase">
                {t.pages.services.title}
              </h2>
            </Reveal>
            <Reveal className="lg:col-span-2" delay={120}>
              <p className="text-lg text-black/75 leading-relaxed">{t.pages.services.subtitle}</p>
            </Reveal>
          </div>

          <div className="border-t border-black/10">
            {t.pages.services.items.map((s, i) => (
              <Reveal
                key={s.n}
                delay={i * 60}
                className="grid grid-cols-12 gap-6 lg:gap-12 items-start border-b border-black/10 py-10 lg:py-14 group hover:bg-[#fafafa] transition-colors"
              >
                <div className="col-span-2 lg:col-span-1">
                  <p className="text-3xl lg:text-5xl font-bold text-[#C20E1A] tracking-tighter">
                    {s.n}
                  </p>
                </div>
                <div className="col-span-10 lg:col-span-5">
                  <h3 className="text-2xl sm:text-3xl lg:text-4xl font-bold uppercase tracking-tight text-black group-hover:text-[#C20E1A] transition-colors">
                    {s.title}
                  </h3>
                </div>
                <div className="col-span-12 lg:col-span-6 lg:pt-2">
                  <p className="text-base text-black/70 leading-relaxed">{s.body}</p>
                </div>
              </Reveal>
            ))}
          </div>

          <Reveal className="mt-20 text-center">
            <Link
              to={route("contact")}
              data-testid="services-contact-btn"
              className="inline-block bg-[#C20E1A] text-white px-10 py-5 text-[11px] uppercase tracking-[0.3em] font-bold hover:bg-black transition-colors duration-500"
            >
              {t.contactStrip.cta}
            </Link>
          </Reveal>
        </div>
      </section>
    </div>
  );
}
